import React, { useCallback, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { PLAN_OPTION_CHARGE_KIND } from '../../constants';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'

SwiperCore.use([Navigation, Pagination]);

const ModalPlanOptionDetail = (props) => {
  const {
    title,
    open,
    onClose,
    goods,
    itineraryIndex,
    onSelectGoods,
    people,
    selectedPeopleCounts
  } = props;
  
  const [selectedCalendarList, setSelectedCalendarList] = useState(null);
  const defaultPeopleCounts = {
    AD: 0,
    SN: 0,
    OT: 0,
    ZP: 0,
    MD: 0,
    CA: 0,
    CB: 0,
    CC: 0,
    IF: 0,
    DATE: "",
    chargesList: [],
  }
  const [peopleCounts, setPeopleCounts] = useState(defaultPeopleCounts);

  // テキスト切り詰め対象の要素
  const noticeInfoTextRef = useRef(null);
  const noticeAndOthersRef = useRef(null);
  const meeingPlaceRef = useRef(null);
  const planExplanationDetailRef = useRef(null);
  const [requireMoreButtonNoticeInfoText, setRequireMoreButtonNoticeInfoText] = useState(false);
  const [requireMoreButtonNoticeAndOthers, setRequireMoreButtonNoticeAndOthers] = useState(false);
  const [requireMoreButtonMeeingPlace, setRequireMoreButtonMeeingPlace] = useState(false);
  const [requireMoreButtonPlanExplanationDetail, setRequireMoreButtonPlanExplanationDetail] = useState(false);
  const [isExpandedNoticeInfoText, setIsExpandedNoticeInfoText] = useState(false);
  const [isExpandedNoticeAndOthers, setIsExpandedNoticeAndOthers] = useState(false);
  const [isExpandedMeeingPlace, setIsExpandedMeeingPlace] = useState(false);
  const [isExpandedPlanExplanationDetail, setIsExpandedPlanExplanationDetail] = useState(false);
  const [selectedAdultNumber, setSelectedAdultNumber] = useState(0);
  const [selectedChildNumber, setSelectedChildNumber] = useState(0);
  const [errorMessages, setErrorMessages] = useState([]);
  const errorMessageRef = useRef(null);

  const resetExpandableTextStates = useCallback(() => {
    setIsExpandedNoticeInfoText(false);
    setIsExpandedNoticeAndOthers(false);
    setIsExpandedMeeingPlace(false);
    setIsExpandedPlanExplanationDetail(false);
    setRequireMoreButtonNoticeInfoText(false);
    setRequireMoreButtonNoticeAndOthers(false);
    setRequireMoreButtonMeeingPlace(false);
    setRequireMoreButtonPlanExplanationDetail(false);
  }, []);

  // 画像サイズに基づいてCSSクラスを適用
  function applyImageSizeClass(img) {
    const naturalWidth = img.naturalWidth;
    const naturalHeight = img.naturalHeight;
    
    // 幅280px未満または高さ187px未満の場合は小さい画像として扱う
    if (naturalWidth < 280 || naturalHeight < 187) {
        img.classList.add('small-image');
    } else {
        img.classList.remove('small-image');
    }
  }

  // モーダルが開かれた時にselectedCalendarListとpeopleCountsを初期化
  useEffect(() => {
    if (open && goods && goods.calendarList && goods.calendarList.length > 0) {
      const isGroup = goods.goodsDetailInfo.useUnit === 'group';
      
      // selectedPeopleCountsが存在する場合
      if (selectedPeopleCounts) {
        setPeopleCounts(selectedPeopleCounts);
        
        // selectedPeopleCounts.DATEの日付に該当するカレンダーを検索
        const selectedDate = selectedPeopleCounts.DATE;
        if (selectedDate) {
          const matchingCalendar = goods.calendarList.find((calendar) => {
            const targetDate = `${calendar.year}-${calendar.month}-${calendar.day}`;
            return targetDate === selectedDate;
          });
          
          if (matchingCalendar) {
            setSelectedCalendarList(matchingCalendar);
            
            // 在庫チェック
            if (matchingCalendar.stocks <= 0) {
              setErrorMessages(['指定の日付には空きがありません']);
            } else {
              setErrorMessages([]);
            }
            return; // 早期リターンで処理を終了
          }
        }
      }

      // selectedPeopleCountsが空または該当する日付が見つからない場合は最初のカレンダーを使用（在庫があるものから）
      const firstCalendar = goods.calendarList.find((calendar) => calendar.stocks > 0);
      setSelectedCalendarList(firstCalendar);
      
      // peopleCountsの初期値
      const initialPeopleCounts = {
        ...defaultPeopleCounts,
        DATE: firstCalendar.year + '-' + firstCalendar.month + '-' + firstCalendar.day,
        chargesList: firstCalendar.chargesList
      };

      // isGroupがtrueの場合はADに1をセット
      if (isGroup){
        initialPeopleCounts.AD = 1;
      }

      setPeopleCounts(initialPeopleCounts);
      
      // 在庫チェック
      if (firstCalendar.stocks <= 0) {
        setErrorMessages(prev => [...prev, '指定の日付には空きがありません']);
      } else {
        setErrorMessages([]);
      }
    }
  }, [open, goods, selectedPeopleCounts]);

  // モーダルを閉じたら展開状態をリセット（ReactModalはアンマウントされないためstateが残りうる）
  useEffect(() => {
    if (open) return;
    resetExpandableTextStates();
    setErrorMessages([]);
  }, [open, resetExpandableTextStates]);

  useEffect(() => {
    setSelectedAdultNumber(peopleCounts.AD + peopleCounts.SN + peopleCounts.OT + peopleCounts.ZP + peopleCounts.MD);
    setSelectedChildNumber(peopleCounts.CA + peopleCounts.CB + peopleCounts.CC + peopleCounts.IF);
  }, [peopleCounts]);

  const adultNumber = people.adult;
  const childNumber = people.childrenA + people.childrenB + people.childrenC + people.children2 + people.infant;
  const hasChildrenCharge = goods ? goods.calendarList[0].chargesList.some((charge) => (charge.kind === 'CA' || charge.kind === 'CB' || charge.kind === 'CC' || charge.kind === 'IF') && Number(charge.price) !== -1) : null;

  //確定ボタンクリック時の処理
  const handleClickSelect = () => {

    // 選択した日付と人数の情報をlocalStorageに保存
    onSelectGoods(goods, itineraryIndex, peopleCounts)
  }

  useEffect(() => {
    if(!errorMessages.length) return;
    if(errorMessageRef.current) {
      errorMessageRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [errorMessages]);
  
  // goodsがnullまたはundefinedの場合
  if (!goods || !goods.calendarList) {
    return null;
  }
  const isGroup = goods.goodsDetailInfo.useUnit === 'group';
  const { calendarList } = goods;
  
  // calendarListが空の場合
  if (!calendarList || calendarList.length === 0) {
    return null;
  }

  // selectedCalendarListが初期化されていない場合
  if (selectedCalendarList === null) {
    return null;
  }

  //日付選択した時の処理
  const handleChangeCalendar = (e) => {
    const selectedDate = e.target.value;
    const selectedCalendar = calendarList.find((calendar) => {
      const targetDate = `${calendar.year}-${calendar.month}-${calendar.day}`;
      return targetDate === selectedDate;
    });
    
    if (selectedCalendar) {
      setSelectedCalendarList(selectedCalendar);
      setPeopleCounts(prev => ({
        ...prev,
        DATE: selectedDate,
        chargesList: selectedCalendar.chargesList
      }));

      if(selectedCalendar.stocks <= 0) {
        setErrorMessages(prev => [...prev, '指定の日付には空きがありません']);
      }else{
        setErrorMessages([]);
      }
    }
  };

  // カウンター増加処理
  const handleIncrement = (type, max) => {
    setPeopleCounts(prev => ({
      ...prev,
      [type]: Math.min(max, prev[type] + 1)
    }));

    validatePeopleCounts(type, 1);
  };

  // カウンター減少処理
  const handleDecrement = (type, min) => {
    setPeopleCounts(prev => ({
      ...prev,
      [type]: Math.max(min, prev[type] - 1)
    }));

    validatePeopleCounts(type, -1);
  };

  //人数のバリデーションチェック
  const validatePeopleCounts = (type, value) => {
    const errors = [];
    const newPeopleCounts = { ...peopleCounts };
    newPeopleCounts[type] += value;
    const selectedAdultNumber = newPeopleCounts.AD + newPeopleCounts.SN + newPeopleCounts.OT + newPeopleCounts.ZP + newPeopleCounts.MD;
    const selectedChildNumber = newPeopleCounts.CA + newPeopleCounts.CB + newPeopleCounts.CC + newPeopleCounts.IF;

    //台組ではバリデーションチェック不要
    if(!isGroup) {
      if(selectedAdultNumber !== adultNumber) {
        errors.push('選択したおとな（中学生以上）の人数が、前の画面で選択したおとなの合計と合うように入力してください。');
      }

      // こどもの料金設定がない場合、おとなのみ利用する着地素材として、こどもには割付せず予約可能する。
      if(hasChildrenCharge && selectedChildNumber !== childNumber) {
        errors.push('選択したこども（小学生以下）の人数が、前の画面で選択したこどもの合計と合うように入力してください。');
      }
    }

    // エラーがある場合はエラーメッセージを設定
    if(errors.length > 0) {
      setErrorMessages(errors);
    }else{
      setErrorMessages([]);
    }
  }

  const handleCloseModal = () => {
    setErrorMessages([]);
    resetExpandableTextStates();
    if (onClose) onClose();
  }

  // テキストの切り詰めとボタン表示をチェックする
  const checkAndTruncateText = (textElementRef, setRequireMoreButton) => {

    if(!textElementRef.current) return;

    const textElement = textElementRef.current;
    const originalHTML = textElement.innerHTML.trim();
    const isMobile = window.innerWidth <= 768;
    const lineLimit = isMobile ? 7 : 6;

    // まず全文表示状態にして高さを測定できるようにする
    textElement.innerHTML = originalHTML;
    textElement.style.setProperty('height', 'auto', 'important');
    textElement.style.setProperty('overflow', 'visible', 'important');
    textElement.style.setProperty('text-overflow', 'unset', 'important');
    textElement.classList.remove('modal__text--truncated');

    const fullHeight = textElement.offsetHeight;

    // lineHeightの計算
    let lineHeight = parseFloat(getComputedStyle(textElement).lineHeight);
    if (isNaN(lineHeight) || lineHeight === 0) {
      const fontSize = parseFloat(getComputedStyle(textElement).fontSize);
      if (!isNaN(fontSize) && fontSize > 0) {
        lineHeight = fontSize * 1.6;
      } else {
        lineHeight = 24;
      }
    }

    const maxHeight = lineHeight * lineLimit;

    if (fullHeight > maxHeight) {
      // テキストが指定行数より長い場合、切り詰める
      textElement.style.setProperty('height', maxHeight + 'px', 'important');
      textElement.style.setProperty('overflow', 'hidden', 'important');
      textElement.style.setProperty('text-overflow', 'clip', 'important');
      textElement.classList.add('modal__text--truncated');
      setRequireMoreButton(true);
    } else {
      // テキストが切り詰められなかった = ボタン不要
      textElement.style.setProperty('overflow', 'visible', 'important');
      textElement.style.setProperty('height', 'auto', 'important');
      textElement.style.setProperty('text-overflow', 'unset', 'important');
      textElement.classList.remove('modal__text--truncated');
      setRequireMoreButton(false);
    }
  }

  // もっと見るボタンクリック
  const toggleText = (textElementRef, isExpanded, setIsExpanded) => {
    if(!textElementRef.current) {
      return;
    }

    const textElement = textElementRef.current;
    const isMobile = window.innerWidth <= 768;
    const lineLimit = isMobile ? 7 : 6;

    if(isExpanded) {
      // 閉じる
      const lineHeight = parseFloat(getComputedStyle(textElement).lineHeight);
      const maxHeight = lineHeight * lineLimit;
      textElement.style.setProperty('height', maxHeight + 'px', 'important');
      textElement.style.setProperty('overflow', 'hidden', 'important');
      textElement.style.setProperty('text-overflow', 'clip', 'important');
      textElement.classList.add('modal__text--truncated');
      setIsExpanded(false);
    } else {
      // 展開：全文表示
      textElement.style.setProperty('height', 'auto', 'important');
      textElement.style.setProperty('overflow', 'visible', 'important');
      textElement.style.setProperty('text-overflow', 'unset', 'important');
      textElement.classList.remove('modal__text--truncated');
      setIsExpanded(true);
    }
  }
  
  return (
      <ReactModal
        isOpen={open}
        closeTimeoutMS={300}
        id="selectModal"
        className={{
          base: `selectModal modal micromodal-slide ${open ? 'is-open' : ''} content-ready`,
          afterOpen: "ReactModal__Content--after-open",
          beforeClose: "ReactModal__Content--before-close",
        }}
        overlayClassName={'overlay selectModalOverlay'}
        bodyOpenClassName=""
        style={{
          overlay: {
            transition: 'opacity 300ms ease-in-out',
          },
        }}
        onRequestClose={handleCloseModal}
        // shouldCloseOnOverlayClick={true}
        ariaHideApp={false}
        onAfterOpen={() => {
          // ローディング表示：1.5秒後に.content-readyクラスを付与
          setTimeout(() => {
            const modalElement = document.querySelector('.selectModal');
            if (modalElement) {
              modalElement.classList.add('content-ready');
            }
          }, 1500);

          // テキスト切り詰め＆もっと見るボタン表示制御
          checkAndTruncateText(noticeInfoTextRef, setRequireMoreButtonNoticeInfoText);
          checkAndTruncateText(noticeAndOthersRef, setRequireMoreButtonNoticeAndOthers);
          checkAndTruncateText(meeingPlaceRef, setRequireMoreButtonMeeingPlace);
          checkAndTruncateText(planExplanationDetailRef, setRequireMoreButtonPlanExplanationDetail);
        }}
      >
        <div className="modal__inner">
          <button className="modal__close" aria-label="Close modal" data-micromodal-close onClick={handleCloseModal}></button>
          <div className="modal__container" role="dialog" aria-modal="true" aria-labelledby="selectModal-title">
          
            <div className="modal__header-tab">
              <div className="modal__tab active">{title}</div>
            </div>
            
            <div className="modal__body">
              <div className="modal__loading">
                <span className="dli-loading"></span>
                <p>読み込み中...</p>
              </div>
              
              <div className="modal__scroll-content" style={{scrollBehavior: "auto"}}>
                <div className="modal__main-content">
                <div className="modal__title-section">
                  <h2 className="modal__title" id="selectModal-title">
                  ＜{goods.goodsDetailInfo.categoryDetail}＞{goods.landFacilityName} {goods.goodsName} {goods.goodsPlanName}／ {goods.area2Name} {goods.area3Name}
                  </h2>
                </div>
              
                <main className="modal__content" id="selectModal-content">
                  <div className="modal__image-section">
                    <Swiper
                      className="swiper"
                      slidesPerView={1}
                      loop={false}
                      onSwiper={() => {
                        const modal = document.querySelector('.selectModal');
                        const slides = document.querySelectorAll('.swiper-slide');
                        if (modal && slides.length <= 1) {
                          modal.classList.add('single-slide');
                        }
                      }}
                      observer={true}
                      observeParents={true}
                      navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                      }}
                      pagination={{
                        el: '.swiper-pagination',
                        clickable: true,
                        type: 'bullets',
                      }}
                    >
                    {goods.images.length > 0 ? (goods.images.map((image) => {
                      return (
                        <SwiperSlide key={image.seq}>
                          <img src={image.url} alt="" />
                        </SwiperSlide>
                      )
                    })) : (
                      <SwiperSlide>
                        <img src={'/dp-air/img/noimage.png'} alt="" />
                      </SwiperSlide>
                    )}
                    </Swiper>
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>
                    <div className="swiper-pagination"></div>
                  </div>
                {goods.landFacilityInfo.noticeInfoText && (
                <div className="modal__section modal-accordion">
                  <div className="modal__section-header">
                    <div className="modal__section-icon"></div>
                    <h3 className="modal__section-title">施設からのお知らせ</h3>
                  </div>
                  <div className="modal__section-content modal__section-content--notice">
                    <div className="modal__text-content">
                      <div className="modal__text" ref={noticeInfoTextRef}>
                        <p dangerouslySetInnerHTML={{ __html: goods.landFacilityInfo.noticeInfoText }}></p>
                      </div>
                      {requireMoreButtonNoticeInfoText && (
                        <button className={`modal__toggle-btn ${isExpandedNoticeInfoText ? 'expanded' : 'collapsed'}`}
                        onClick={() => toggleText(noticeInfoTextRef, isExpandedNoticeInfoText, setIsExpandedNoticeInfoText)}
                      >
                        <span>{isExpandedNoticeInfoText ? '閉じる' : 'もっと見る'}</span>
                      </button>
                      )}
                    </div>
                  </div>
                </div>
                )}
                {goods.noticeAndGuidance.noticeAndOthers && (
                <div className="modal__section modal-accordion">
                  <div className="modal__section-header">
                    <div className="modal__section-icon"></div>
                    <h3 className="modal__section-title">ご案内ご注意</h3>
                  </div>
                  <div className="modal__section-content modal__section-content--notice">
                    <div className="modal__text-content">
                      <div className="modal__text" ref={noticeAndOthersRef}>
                        <p dangerouslySetInnerHTML={{ __html: goods.noticeAndGuidance.noticeAndOthers }}></p>
                      </div>
                      {requireMoreButtonNoticeAndOthers && (
                        <button className={`modal__toggle-btn ${isExpandedNoticeAndOthers ? 'expanded' : 'collapsed'}`}
                          onClick={() => toggleText(noticeAndOthersRef, isExpandedNoticeAndOthers, setIsExpandedNoticeAndOthers)}
                        >
                          <span>{isExpandedNoticeAndOthers ? '閉じる' : 'もっと見る'}</span>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                )}
                {goods.noticeAndGuidance.meeingPlace && (
                <div className="modal__section modal-accordion">
                  <div className="modal__section-header">
                    <div className="modal__section-icon"></div>
                    <h3 className="modal__section-title">集合場所・引き換え場所</h3>
                  </div>
                  <div className="modal__section-content">
                    <div className="modal__text-content">
                      <div className="modal__text" ref={meeingPlaceRef}>
                        <p dangerouslySetInnerHTML={{ __html: goods.noticeAndGuidance.meeingPlace }}></p>
                      </div>
                      {requireMoreButtonMeeingPlace && (
                        <button className={`modal__toggle-btn ${isExpandedMeeingPlace ? 'expanded' : 'collapsed'}`}
                          onClick={() => toggleText(meeingPlaceRef, isExpandedMeeingPlace, setIsExpandedMeeingPlace)}
                        >
                          <span>{isExpandedMeeingPlace ? '閉じる' : 'もっと見る'}</span>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                )}
                {goods.goodsBasicInfo.planExplanationDetail && (
                <div className="modal__section modal-accordion">
                  <div className="modal__section-header">
                    <div className="modal__section-icon"></div>
                    <h3 className="modal__section-title">このプランのポイント</h3>
                  </div>
                  <div className="modal__section-content">
                    <div className="modal__text-content">
                      <div className="modal__text" ref={planExplanationDetailRef}>
                        <p dangerouslySetInnerHTML={{ __html: goods.goodsBasicInfo.planExplanationDetail }}></p>
                      </div>
                      {requireMoreButtonPlanExplanationDetail && (
                        <button className={`modal__toggle-btn ${isExpandedPlanExplanationDetail ? 'expanded' : 'collapsed'}`}
                          onClick={() => toggleText(planExplanationDetailRef, isExpandedPlanExplanationDetail, setIsExpandedPlanExplanationDetail)}
                        >
                          <span>{isExpandedPlanExplanationDetail ? '閉じる' : 'もっと見る'}</span>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                )}
                <div className="modal__section">
                  <div className="modal__section-header">
                    <div className="modal__section-icon"></div>
                    <h3 className="modal__section-title">利用日・利用数を選択してください</h3>
                  </div>
                  {errorMessages.length > 0 && 
                  <div className="is-invalid" ref={errorMessageRef}>
                    {errorMessages.map((errorMessage, index) => (
                      <p className="error-message" key={index}>{errorMessage}</p>
                    ))}
                  </div>
                  }
                  <div className="modal__people-selection">
                    <div className="modal__people-group">
                      <div className="selectWrapper formTextSpaceRight">
                        <select 
                          value={selectedCalendarList ? `${selectedCalendarList.year}-${selectedCalendarList.month}-${selectedCalendarList.day}` : ''} 
                          onChange={handleChangeCalendar}
                        >
                          {
                            calendarList.map((calendar) => {
                              const date = `${calendar.year}-${calendar.month}-${calendar.day}`;
                              const dateString = `${calendar.year}年${calendar.month}月${calendar.day}日`;
                              const status = calendar.stocks > 0 ? '〇' : '×';
                              return (
                                <option key={date} value={date} disabled={calendar.stocks <= 0}>{dateString}　空き状況：{status}</option>
                              );
                            })
                          }
                        </select>
                      </div>
                      <div className="modal__people-list">
                        {
                          selectedCalendarList.chargesList
                            .filter((charge) => Number(charge.price) !== -1)
                            .map((charge) => {
                            const planOptionKindList = PLAN_OPTION_CHARGE_KIND.find((kind) => charge.kind === kind.id);
                            const displayPersonExplanation = isGroup ? '合計差額' : (planOptionKindList.name + (charge.personExplanation ? `<br /><span>${charge.personExplanation}</span>` : ''));
                            const displayPriceDiff = charge.priceDiff >= 0 ? `+${Number(charge.priceDiff).toLocaleString()}円` : `${Number(charge.priceDiff).toLocaleString()}円`;
                            const maxNumber = (charge.kind === 'AD' || charge.kind === 'SN' || charge.kind === 'OT' || charge.kind === 'ZP' || charge.kind === 'MD') ? adultNumber : childNumber;
                            const isDisabled = (charge.kind === 'AD' || charge.kind === 'SN' || charge.kind === 'OT' || charge.kind === 'ZP' || charge.kind === 'MD') ? ((adultNumber - selectedAdultNumber) === 0) : ((childNumber - selectedChildNumber) === 0);
                            const numberOfGroups = (charge.kind === 'AD') ? charge.numberOfGroups : 0;

                            return (
                              <div className="modal__people-item" key={charge.kind}>
                                <div className="modal__people-info">
                                  <span className="modal__people-type" dangerouslySetInnerHTML={{ __html: displayPersonExplanation }}></span>
                                  <span className="modal__people-price">{displayPriceDiff}</span>
                                </div>
                                {isGroup ? (
                                  <div className="modal__counter">
                                    <span className="counter__label">予約数</span>
                                    <span className="counter__value" aria-live="polite">{numberOfGroups}{goods.goodsDetailInfo.displayUnit}</span>
                                  </div>
                                ) : (
                                  <div className="modal__counter">
                                    <button 
                                      className="counter__btn counter__btn--minus" 
                                      type="button" 
                                      aria-label="減らす"
                                      onClick={() => handleDecrement(charge.kind, 0)}
                                      disabled={peopleCounts[charge.kind] <= 0}
                                    ></button>
                                    <span className="counter__value" aria-live="polite">{peopleCounts[charge.kind]}{goods.goodsDetailInfo.displayUnit}</span>
                                    <button 
                                      className="counter__btn counter__btn--plus" 
                                      type="button" 
                                      aria-label="増やす"
                                      onClick={() => handleIncrement(charge.kind, maxNumber)}
                                      disabled={isDisabled}
                                    ></button>
                                  </div>
                                )}
                              </div>
                            );
                          })
                        }
                      </div>
                    </div>
                  </div>
                </div>
                </main>
              </div>
            </div>
              
            <div className="modal__footer">
              <button className="modal__confirm-btn modal__button"
              type="button"
              data-micromodal-close
              onClick={() => handleClickSelect()}
              disabled={selectedCalendarList.stocks <= 0 || errorMessages.length > 0 || selectedAdultNumber === 0}
            >確定する</button>
            </div>
          </div>
        </div>
        </div>
      </ReactModal>
  );
};

ModalPlanOptionDetail.defaultProps = {
  className: '',
  overlayClassName: '',
  bodyClassName: '',
  modalContentClassName: '',
  goods: {},
  itineraryIndex: 0,
  people: {},
  selectedPeopleCounts: {},
};

ModalPlanOptionDetail.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  goods: PropTypes.object,
  itineraryIndex: PropTypes.number,
  onSelectGoods: PropTypes.func,
  people: PropTypes.object,
  selectedPeopleCounts: PropTypes.object,
};

export default ModalPlanOptionDetail;